// extracted by mini-css-extract-plugin
export var discard = "_36-3";
export var muiTooltipTooltip = "_36-5";
export var notificationBar = "_36-2";
export var saveButtonHoverSlotWrapper = "_36-4";
export var show = "_36-1";
export var spacer = "_36-0";